/**
 * LERA Smart Selector — Controller (Sprint 8.3C.3)
 * <lera-smart-selector> owns initialization, state, and variant:selected events.
 */
window.LeraSmartSelector = window.LeraSmartSelector || {};

(function (LSS) {
  if (customElements.get('lera-smart-selector')) return;

  customElements.define(
    'lera-smart-selector',
    class LeraSmartSelectorElement extends HTMLElement {
      constructor() {
        super();
        this._catalog = [];
        this._state = null;
        this._variantRoot = null;
        this._onChange = this._onChange.bind(this);
        this._onMutate = this._onMutate.bind(this);
      }

      connectedCallback() {
        if (this._initialized) {
          this._resync();
          return;
        }

        this._initialized = true;
        this._catalog = LSS.readCatalog(this);
        this._state = LSS.createState(LSS.bridge.readConfigFromHost(this));
        this._observer = new MutationObserver(this._onMutate);
        this._observer.observe(this, { childList: true, subtree: true });

        this.addEventListener('change', this._onChange, true);
        this._bindVariantRoot();
        this._resync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange, true);
        this._observer?.disconnect();
        this._variantRoot = null;
        this._bootstrapped = false;
      }

      get state() {
        return this._state ? Object.assign({}, this._state, { selectedOptions: this._state.selectedOptions.slice() }) : null;
      }

      get hooks() {
        return LSS.hooks;
      }

      _bindVariantRoot() {
        const nextRoot = LSS.bridge.getVariantRoot(this);
        if (nextRoot === this._variantRoot) return;
        this._variantRoot = nextRoot;
      }

      _onMutate() {
        this._bindVariantRoot();
        window.requestAnimationFrame(() => this._resync());
      }

      _onChange(event) {
        if (!this._variantRoot?.contains(event.target)) return;
        this._resync();
      }

      _resync() {
        this._bindVariantRoot();
        const previousVariantId = this._state?.variantId ?? null;
        const selectedOptions = LSS.readSelectedOptionsFromDOM(this._variantRoot);
        const fallbackVariant = LSS.readSelectedVariantNode(this._variantRoot);
        const variant = LSS.resolveVariant(this._catalog, selectedOptions, fallbackVariant);

        this._state = LSS.patchState(this._state, {
          selectedOptions,
          variant,
          variantId: variant?.id ?? null,
        });

        if (!this._bootstrapped) {
          this._bootstrapped = true;
          return;
        }

        if (this._state.variantId === previousVariantId) return;

        const detail = LSS.createEventDetail(this._state, previousVariantId);
        LSS.dispatchVariantSelected(this, detail);
        LSS._notifyVariantSelected(detail);
        LSS.bridge.syncFormVariantInput(this._state.sectionId, this._state.variantId);
      }
    }
  );

  LSS.getInstance = function getInstance(root) {
    if (!root) return null;
    if (root.matches?.('lera-smart-selector')) return root;
    return root.querySelector?.('lera-smart-selector') || null;
  };

  LSS.getState = function getState(root) {
    const instance = LSS.getInstance(root);
    return instance?.state ?? null;
  };
})(window.LeraSmartSelector);
